<div class="overview-container">
    <div class="table-header">
        <h2>Übersicht Krankmeldungen</h2>
    </div>

    <div class="filter-section">
        <div class="filter-field">
            <label for="employeeFilter">Nach Mitarbeiter filtern:</label>
            <select
                    id="employeeFilter"
                    class="filter-select"
                    [ngModel]="selectedEmployee()"
                    (ngModelChange)="selectedEmployee.set($event); onEmployeeFilterChange()"
            >
                <option value="">Alle Mitarbeiter</option>
                <option *ngFor="let employee of employees()" [value]="employee.datevEmployeeNumber">
                    {{employee.name}} ({{employee.datevEmployeeNumber}})
                </option>
            </select>
        </div>
        <div class="filter-results" *ngIf="selectedEmployee()">
            {{ filteredSickLeaves().length }} von {{ sickLeaves().length }} Krankmeldungen
        </div>
    </div>

    <div class="auth-required-message" *ngIf="!datevAuthService.getAuthStatus()()">
        Für Einreichen/Abholen/Stornieren ist eine DATEV-Authentifizierung erforderlich.
        <button type="button" class="datev-login-button" (click)="datevAuthService.loginDatev()">
            Bei DATEV anmelden
        </button>
    </div>

    <div class="loading-spinner" *ngIf="loading()">
        <svg class="spinner-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#007bff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
        </svg>
        Lade Daten...
    </div>

    <div class="table-container" *ngIf="!error() && !loading()">
        <table>
            <thead>
            <tr>
                <th>Mitarbeiternummer</th>
                <th>Beginn AU</th>
                <th>Ende AU</th>
                <th>Status</th>
                <th>Fehlergrund</th>
                <th>Aktionen</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let leave of filteredSickLeaves()"
                [class.cancelled]="isCancelled(leave.status)"
                [class.error-status]="isError(leave.status)">
                <td>{{leave.mitarbeiterID}}</td>
                <td>{{leave.von | date:'dd.MM.yyyy'}}</td>
                <td>{{leave.bis | date:'dd.MM.yyyy'}}</td>
                <app-eau-row-actions [leave]="leave" (actionCompleted)="refreshSickLeavesSilently()"></app-eau-row-actions>
            </tr>
            <tr *ngIf="filteredSickLeaves().length === 0">
                <td colspan="6" class="no-data">Keine Krankmeldungen vorhanden</td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
